import { useAppSelector } from "store/hooks";
import { selectAdmissionsDeadline } from "store/slices/user";

import { ONE_WEEK_IN_MILLISECONDS } from "const";

export const useWeeksCount = () => {
  const admissionsDeadline = useAppSelector(selectAdmissionsDeadline);

  const weeksCount = Math.max(
    Math.floor((new Date(admissionsDeadline).getTime() - new Date().getTime()) / ONE_WEEK_IN_MILLISECONDS),
    0,
  );

  return { weeksCount };
};
